import { render } from "./InvoicesHeader.vue?vue&type=template&id=1a43000a"
import script from "./InvoicesHeader.vue?vue&type=script&lang=js"
export * from "./InvoicesHeader.vue?vue&type=script&lang=js"
script.render = render

export default script